<mat-form-field
  appearance="outline"
  [color]="model.getAdditional('color', 'primary')"
  [ngClass]="getClass('grid', 'control')"
  [formGroup]="group"
  [class]="model.id"
>
  @if (model.label) {
  <ng-container ngProjectAs="mat-label">
    <mat-label [innerHTML]="model.label"></mat-label>
  </ng-container>
  } @if (model.prefix) {
  <span matPrefix [innerHTML]="model.prefix"></span>
  }

  <mat-select
    #matSelect
    [compareWith]="model.compareWithFn"
    [disableOptionCentering]="model.getAdditional('disableOptionCentering', true)"
    [disableRipple]="model.getAdditional('disableRipple', (RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled']) || false)"
    [errorStateMatcher]="model.getAdditional('errorStateMatcher', errorStateMatcher)"
    [formControlName]="model.id"
    [id]="id"
    [multiple]="model.multiple"
    [ngClass]="getClass('element', 'control')"
    [placeholder]="model.placeholder"
    [required]="model.required"
    (openedChange)="onCustomEvent($event, 'openedChange')"
    (selectionChange)="onChange($event)"
  >
    @for (option of model.options$ | async; track option) {
    <mat-option
      [ngClass]="model.getAdditional('optionClass')"
      [disabled]="option.disabled"
      [ngClass]="getClass('element', 'option')"
      [value]="option.value"
      ><span [innerHTML]="option.label"></span
    ></mat-option>
    }
  </mat-select>

  @if (model.suffix) {
  <span matSuffix [innerHTML]="model.suffix"></span>
  } @if (model.hint !== null) {
  <mat-hint align="start" [innerHTML]="model.hint"></mat-hint>
  } @for (message of errorMessages; track message) {
  <mat-error>{{ message }}</mat-error>
  }
</mat-form-field>
